export default {
  heading: '"Inter", -apple-system, system-ui, sans-serif',
  body: '"Inter", -apple-system, system-ui, sans-serif',
};
